import React from "react";
import { Modal } from "antd";
import { useSelector } from "react-redux";
import Confirmation from "../Confirmation";

const ConfirmationModel = ({ title, width }) => {
  const { layout } = useSelector((state) => state);
  return (
    <>
      <Modal
        title={title}
        open={layout?.isNotify}
        width={width}
        footer={null}
        centered
      >
        <Confirmation />
      </Modal>
    </>
  );
};

export default ConfirmationModel;
